import { defineComponent, ref, computed, createBlock, openBlock, unref, withCtx, createElementVNode, normalizeClass, createVNode, renderSlot, Teleport, normalizeStyle, mergeProps } from "vue";
import { useFloating, offset, flip, shift, autoUpdate } from "@floating-ui/vue";
import { Menu, MenuButton, MenuItems } from "@headlessui/vue";
import { useResizeObserver } from "@vueuse/core";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "FlowDropdown",
  props: {
    placement: {},
    static: { type: Boolean },
    resize: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const dropdownRef = ref(null);
    const buttonWrapper = ref(null);
    const triggerWidth = ref(0);
    const triggerRef = computed(
      () => {
        var _a, _b;
        return ((_b = (_a = buttonWrapper.value) == null ? void 0 : _a.children) == null ? void 0 : _b[0]) || buttonWrapper.value;
      }
    );
    useResizeObserver(triggerRef, ([entry]) => {
      triggerWidth.value = entry.target.clientWidth;
    });
    const { floatingStyles } = useFloating(triggerRef, dropdownRef, {
      placement: props.placement || "bottom-start",
      whileElementsMounted: autoUpdate,
      middleware: [offset(5), flip(), shift()]
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Menu), null, {
        default: withCtx(({ open }) => [
          createElementVNode("div", {
            ref_key: "buttonWrapper",
            ref: buttonWrapper,
            class: normalizeClass({
              "button-wrapper": !!_ctx.$slots.default
            })
          }, [
            createVNode(unref(MenuButton), { as: "template" }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default", { open }, void 0, true)
              ]),
              _: 2
            }, 1024)
          ], 2),
          (openBlock(), createBlock(Teleport, {
            disabled: _ctx.static,
            to: "body"
          }, [
            createElementVNode("div", {
              ref_key: "dropdownRef",
              ref: dropdownRef,
              class: "floating",
              style: normalizeStyle(unref(floatingStyles))
            }, [
              createVNode(unref(MenuItems), mergeProps({
                class: "dropdown",
                style: { width: _ctx.resize ? `${triggerWidth.value}px` : void 0 }
              }, _ctx.$attrs), {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "items", { open }, void 0, true)
                ]),
                _: 2
              }, 1040, ["style"])
            ], 4)
          ], 8, ["disabled"]))
        ]),
        _: 3
      });
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FlowDropdown.vue2.js.map
